// Motor de sonidos UI sintetizados con Web Audio API (sin assets externos).
// Efectos de clic, hover, navegación, apertura/cierre de modales, éxito y error.

let ctx = null;
let muted = false;
// Multiplicador de volumen global para todos los efectos UI (clics, navegación,
// transiciones, deslizamientos, scroll, toques, apertura/cierre, etc.).
// 1.0 = volumen original; subir aquí sube todo de forma proporcional.
const VOLUME = 1.8;
try { muted = localStorage.getItem("bhgc_sound_muted") === "1"; } catch {}

function ensureCtx() {
  if (ctx) return ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  try { ctx = new AC(); } catch { return null; }
  return ctx;
}

function tone({ freq = 600, type = "sine", dur = 0.07, gain = 0.05, slideTo, when = 0 }) {
  if (muted) return;
  const ac = ensureCtx();
  if (!ac) return;
  if (ac.state === "suspended") ac.resume().catch(() => {});
  const t0 = ac.currentTime + when;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  const amp = Math.min(0.32, gain * VOLUME);
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (slideTo) osc.frequency.exponentialRampToValueAtTime(Math.max(1, slideTo), t0 + dur);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.linearRampToValueAtTime(amp, t0 + 0.006);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g).connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.03);
}

const PRESETS = {
  click: () => tone({ freq: 520, type: "triangle", dur: 0.06, gain: 0.09, slideTo: 380 }),
  hover: () => tone({ freq: 880, type: "sine", dur: 0.045, gain: 0.045 }),
  nav: () => tone({ freq: 420, type: "triangle", dur: 0.06, gain: 0.04, slideTo: 680 }),
  open: () => { tone({ freq: 320, type: "triangle", dur: 0.07, gain: 0.04, slideTo: 560 }); tone({ freq: 560, type: "sine", dur: 0.05, gain: 0.02, when: 0.05 }); },
  close: () => tone({ freq: 480, type: "triangle", dur: 0.07, gain: 0.035, slideTo: 220 }),
  success: () => { tone({ freq: 523, type: "triangle", dur: 0.08, gain: 0.04 }); tone({ freq: 784, type: "triangle", dur: 0.1, gain: 0.04, when: 0.07 }); },
  error: () => tone({ freq: 200, type: "sawtooth", dur: 0.12, gain: 0.04, slideTo: 120 }),
  // Acciones específicas
  cancel: () => { tone({ freq: 380, type: "sawtooth", dur: 0.09, gain: 0.04, slideTo: 160 }); tone({ freq: 160, type: "triangle", dur: 0.06, gain: 0.03, when: 0.06 }); },
  clone: () => { tone({ freq: 440, type: "triangle", dur: 0.06, gain: 0.035 }); tone({ freq: 660, type: "triangle", dur: 0.06, gain: 0.035, when: 0.05 }); tone({ freq: 880, type: "triangle", dur: 0.07, gain: 0.035, when: 0.10 }); },
  track: () => { tone({ freq: 600, type: "sine", dur: 0.07, gain: 0.035, slideTo: 1000 }); },
  pickup: () => { tone({ freq: 500, type: "triangle", dur: 0.06, gain: 0.035, slideTo: 720 }); tone({ freq: 720, type: "sine", dur: 0.06, gain: 0.025, when: 0.05 }); },
  generate: () => { tone({ freq: 392, type: "triangle", dur: 0.07, gain: 0.04 }); tone({ freq: 523, type: "triangle", dur: 0.07, gain: 0.04, when: 0.06 }); tone({ freq: 784, type: "triangle", dur: 0.1, gain: 0.04, when: 0.12 }); },
  save: () => tone({ freq: 700, type: "sine", dur: 0.06, gain: 0.035, slideTo: 520 }),
  delete: () => { tone({ freq: 300, type: "sawtooth", dur: 0.1, gain: 0.04, slideTo: 120 }); },
  refresh: () => tone({ freq: 660, type: "sine", dur: 0.05, gain: 0.03, slideTo: 440 }),
  pay: () => { tone({ freq: 523, type: "triangle", dur: 0.06, gain: 0.04 }); tone({ freq: 659, type: "triangle", dur: 0.08, gain: 0.04, when: 0.06 }); },
  print: () => tone({ freq: 550, type: "square", dur: 0.05, gain: 0.025, slideTo: 700 }),
  download: () => tone({ freq: 740, type: "triangle", dur: 0.06, gain: 0.03, slideTo: 480 }),
  copy: () => tone({ freq: 900, type: "sine", dur: 0.04, gain: 0.03 }),
  focus: () => tone({ freq: 740, type: "sine", dur: 0.05, gain: 0.05, slideTo: 920 }),
  blur: () => tone({ freq: 620, type: "sine", dur: 0.04, gain: 0.04, slideTo: 440 }),
  type: () => tone({ freq: 1200 + Math.floor(Math.random() * 220), type: "square", dur: 0.022, gain: 0.02 }),
};

function emit() {
  try { window.dispatchEvent(new CustomEvent("bhgc-sound-change", { detail: { muted } })); } catch {}
}

export const uiSound = {
  play(name) { try { (PRESETS[name] || PRESETS.click)(); } catch {} },
  setMuted(v) { muted = !!v; try { localStorage.setItem("bhgc_sound_muted", muted ? "1" : "0"); } catch {} emit(); },
  isMuted() { return muted; },
  toggle() { this.setMuted(!muted); return muted; },
};

// Sincroniza el muteo entre pestañas (landing <-> plataforma) en tiempo real.
try {
  window.addEventListener("storage", (e) => {
    if (e.key === "bhgc_sound_muted") { muted = e.newValue === "1"; emit(); }
  });
} catch {}

let initialized = false;
export function initUiSounds() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  const isInteractive = (el) =>
    !!(el && el.closest && el.closest('button, a, [role="button"], input[type="submit"], input[type="button"], summary, .cursor-pointer'));

  // Sonido al presionar: usa el efecto semántico definido en [data-sound] si existe.
  window.addEventListener("pointerdown", (e) => {
    const t = e.target;
    const semantic = t && t.closest && t.closest("[data-sound]");
    if (semantic) { uiSound.play(semantic.getAttribute("data-sound") || "click"); return; }
    if (isInteractive(t)) uiSound.play("click");
  }, true);

  // Hover sutil, sin repetir sobre el mismo elemento.
  let lastHover = null;
  window.addEventListener("mouseover", (e) => {
    const btn = e.target && e.target.closest && e.target.closest('button, a, [role="button"]');
    if (btn && btn !== lastHover) { lastHover = btn; uiSound.play("hover"); }
    else if (!btn) { lastHover = null; }
  }, true);

  // Sonido al entrar (focus) y salir (blur) de campos de captura de texto.
  const isField = (el) => {
    if (!el || !el.matches) return false;
    const tag = el.tagName;
    if (tag === "TEXTAREA" || tag === "SELECT") return true;
    if (tag === "INPUT") {
      const t = (el.type || "").toLowerCase();
      return ["text", "email", "password", "search", "tel", "url", "number", "date", "datetime-local", "time", "month"].includes(t);
    }
    if (el.getAttribute && el.getAttribute("contenteditable") === "true") return true;
    return false;
  };
  window.addEventListener("focusin", (e) => {
    if (isField(e.target)) uiSound.play("focus");
  }, true);
  window.addEventListener("focusout", (e) => {
    if (isField(e.target)) uiSound.play("blur");
  }, true);

  // Sonido de tipeo al escribir en campos de texto (con throttle para no saturar).
  let lastType = 0;
  const TYPE_MIN_GAP = 35; // ms entre sonidos
  window.addEventListener("keydown", (e) => {
    const el = e.target;
    if (!el || !el.matches) return;
    const tag = el.tagName;
    const isText = tag === "TEXTAREA" ||
      (tag === "INPUT" && ["text", "email", "password", "search", "tel", "url", "number"].includes((el.type || "").toLowerCase())) ||
      (el.getAttribute && el.getAttribute("contenteditable") === "true");
    if (!isText) return;
    // Ignorar teclas modificadoras / navegación que no agregan texto.
    const k = e.key;
    if (!k || (k.length !== 1 && !["Backspace", "Delete", " "].includes(k))) return;
    const now = performance.now();
    if (now - lastType < TYPE_MIN_GAP) return;
    lastType = now;
    uiSound.play("type");
  }, true);

  // Apertura / cierre de modales (Dialog y aria-modal).
  const isModal = (el) => !!(el && el.matches && el.matches('[role="dialog"], [aria-modal="true"]'));
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach((n) => { if (isModal(n)) uiSound.play("open"); });
      m.removedNodes.forEach((n) => { if (isModal(n)) uiSound.play("close"); });
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
}